<template>
  <div class="onboarding-seeker">
    <ProgressBar :value="progress.currentStep" :max="progress.totalSteps" :content="progressContent" />
    <RouteStepper
      class="w-full mt-32 md:mt-60 md:max-w-[568px] px-16 mx-auto"
      :hideBreadcrumb="true"
      :modelValue="initialDraftData"
      :autoValidateOnInit="true"
      @progress="progress = $event"
      @submit="redirectToAccountCreation"
    />
  </div>
</template>

<script lang="ts">
import RouteStepper from '@/components/route_stepper/RouteStepper.vue';
import ProgressBar from '@/components/progress_bar/ProgressBar.vue';
import { OnboardingSeekerDraft } from './types';
import { redirect } from '@/helpers/redirects';
import { buildUpgradeRedirectLink, RouteQuery } from '@/helpers/utmQueryParams';

export default {
  name: 'OnboardingSeeker',
  components: { RouteStepper, ProgressBar },
  data(): { progress: { currentStep: number; totalSteps: number }; entryQueryParams: RouteQuery } {
    return {
      progress: { currentStep: 1, totalSteps: 1 },
      entryQueryParams: {},
    };
  },
  computed: {
    zipcodeFromQuery(): string | null {
      const raw = this.$route.query.zipcode;
      const value = Array.isArray(raw) ? raw[0] : raw;

      if (typeof value !== 'string') {
        return null;
      }

      const trimmedZip = value.trim();
      if (!trimmedZip) {
        return null;
      }

      return trimmedZip;
    },
    progressContent(): string {
      return `Step ${this.progress.currentStep} of ${this.progress.totalSteps}`;
    },
    initialDraftData(): OnboardingSeekerDraft {
      if (!this.zipcodeFromQuery) {
        return {};
      }

      return { zipCode: this.zipcodeFromQuery };
    },
  },
  created() {
    this.entryQueryParams = { ...this.$route.query };
  },
  methods: {
    redirectToAccountCreation({ zipCode }: OnboardingSeekerDraft): void {
      const params = new URLSearchParams();
      buildUpgradeRedirectLink(params, this.entryQueryParams);
      params.set('member_type', 'seeker');

      if (zipCode) {
        params.set('zip_code', zipCode);
      }

      redirect(`/registration?${params.toString()}`);
    },
  },
};
</script>

<style lang="scss">
.onboarding-seeker .card:not(.card-preserve) {
  padding: 24px;

  @media (max-width: 640px) {
    background-color: transparent !important;
    padding: 0 !important;
    box-shadow: none !important;
  }
}
</style>
